/** Presentation-only Uzbek phone helpers for the dashboard service. */
export function formatUzPhone(raw: string | null | undefined): string {
  if (!raw) return "";
  if (!/^[+()\d\s-]+$/.test(raw)) return raw;
  const digits = raw.replace(/\D/g, "");
  if (!/^998\d{9}$/.test(digits)) return raw;
  return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
}

/** The prefix is initial editable content, never a fixed input adornment. */
export function initialPhoneInput(value?: string | null): string {
  return value || "+998";
}

export function isBlankPhoneInput(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  return digits === "" || digits === "998";
}
